export const creatorsFeedback = [
  /* {
    handle: 'mealsbymitch',
    feedback: [
      'When I was approached in the summer time of last year to launch a cook book and I was that shocked nearly fell off my chair...',
      'The fact that my TikTok content could be brought to life in an actual book was a proper exciting prospect; All I had to do was provide the recipes, photos and a design of my choice, and they did the rest. It was an easy process start to finish and we are currently in  discussion to launch book number two'
    ]
  }, */
  {
    handle: 'letsmunchh',
    feedback: [
      'I cant believe have successfully published my own cookbook. I love the reactions from my follower when they make my recipes.',
      'The speed and process to launch the book was super easy. The team made the experience very simple.'
    ]
  }
];

export const creatorsQuotes = [
  {
    handle: 'ellena_fit',
    image: 'creator1.png',
    quote: 'This is a copy of my Instagram in a book'
  }
];
